import { API_URL } from "../Config";
import { formatDate } from "../DateUtils";
import { IDetailsResponse } from "../IDetailsResponse";
import { GetIncidentDetailsAsync, IIncidentDetails } from "../IIncident";
import { GetLicenseDetailsAsync, ILicenceDetails } from "../LicenceDetails";

export interface IIncidentUpdateRequestDetails extends IDetailsResponse {
  incidentupdaterequestid: string;
  reference: string;
  status: string;
  request: string;
  licenceid: string;
  incidentid: string;
  datesubmitted: string;
  duedate: string;
  incidentDetails?: IIncidentDetails;
  licenceDetails?: ILicenceDetails;
}

export async function GetIncidentUpdateRequestDetailsAsync(
  incidentUpdateRequestId: string
): Promise<IIncidentUpdateRequestDetails> {
  var url = `${API_URL}/Incident/incidentupdaterequestbyid?incident_update_request_id=${incidentUpdateRequestId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/incident-update-request-details`;
  }

  var response = await fetch(url);
  var body = <IIncidentUpdateRequestDetails>await response.json();

  const licenceDetails = await GetLicenseDetailsAsync(body.licenceid);

  if (body.incidentid) {
    body.incidentDetails = await GetIncidentDetailsAsync(body.incidentid);
  }

  return <IIncidentUpdateRequestDetails>{
    response: response,
    incidentupdaterequestid: body.incidentupdaterequestid,
    reference: body.reference,
    status: body.status,
    request: body.request,
    licenceid: body.licenceid,
    incidentid: body.incidentid,
    datesubmitted: formatDate(body.datesubmitted),
    duedate: formatDate(body.duedate),
    incidentDetails: body.incidentDetails,
    licenceDetails: licenceDetails,
  };
}
